var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoobyDooHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29412",
    "data-name": "Group 29412",
    transform: "translate(-221 -422.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(221 422.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29404",
    "data-name": "Group 29404",
    transform: "translate(239 428.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50248",
    "data-name": "Path 50248",
    d: "M23.988,9.616a3.536,3.536,0,0,0-3.25,0,1.751,1.751,0,0,1-2.321-.929c-.723-1.13-1.693-1.373-3.25-.929-3.25.929-4.527,4.121-4.991,7.371s1.741,11.2,1.741,11.2H21.2a47.116,47.116,0,0,0-1.134-5.922,3.639,3.639,0,0,0,.762-1.113,1.5,1.5,0,0,0,1.3-1.322,1.039,1.039,0,0,0-.018-.131c1.282.28.967-1.272,2.8-2.19C26.774,14.723,24.917,10.08,23.988,9.616Z",
    transform: "translate(-9.614 -4.044)",
    fill: "#b0720c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50249",
    "data-name": "Path 50249",
    d: "M10.878,7.893S7.947,5.571,9.485,3.714c-.464-1.857,0-3.689.929-3.714.734-.02.929,2.321.929,2.321s2.321.929.464,3.714A2.012,2.012,0,0,1,10.878,7.893Z",
    transform: "translate(-9.039 0)",
    fill: "#b0720c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50250",
    "data-name": "Path 50250",
    d: "M22.321,0c-.464,0-.929.929-1.857,1.393-.831.415.464,1.857-.464,2.786a3.573,3.573,0,0,1,2.786.464s1.6-1.845-.254-2.773C23.354.869,23.25,0,22.321,0Z",
    transform: "translate(-14.911 0)",
    fill: "#b0720c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50251",
    "data-name": "Path 50251",
    d: "M19.848,19s-.629,2.285.864,2.435c.708.071,1.022-.963,1.526-.874s-.266,2.874,1.659,3.408a4.415,4.415,0,0,0,5.216-4c-.474-.03-.622-.03-.622-.03a3.835,3.835,0,0,1-4.06,3.349c-2.1-.022-.889-3.023-1.986-3.275-1-.229-1.082.711-1.689.711C19.719,20.724,19.848,19,19.848,19Z",
    transform: "translate(-14.759 -10.178)",
    fill: "#6d4408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50252",
    "data-name": "Path 50252",
    d: "M19.34,26.128c.771,4.934,4.608,5.868,5.72,3.052a.72.72,0,0,1,.563.148C25.386,31.507,19.829,34.04,19.34,26.128Z",
    transform: "translate(-14.557 -13.997)",
    fill: "#6d4408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50253",
    "data-name": "Path 50253",
    d: "M28.085,29.591a3.183,3.183,0,0,0,2.756.859c1.452-.415.815-2.726.815-2.726l-.726.267s.622,1.571-.356,1.9A4.493,4.493,0,0,1,28.085,29.591Z",
    transform: "translate(-19.242 -14.852)",
    fill: "#6d4408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50254",
    "data-name": "Path 50254",
    d: "M20.736,10A2.286,2.286,0,0,0,19,11.967c-.062,1.015,2.015,1.353,2.291-.571C21.448,10.317,20.933,10,20.736,10Z",
    transform: "translate(-14.375 -5.357)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50255",
    "data-name": "Path 50255",
    d: "M26.284,10.473c.5,0,.981.635,1.031,1.447s-1.213,1.137-1.434-.4C25.757,10.655,26.125,10.47,26.284,10.473Z",
    transform: "translate(-18.048 -5.61)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50256",
    "data-name": "Path 50256",
    d: "M11.924,1.155c-.035.4-.356,3.734.067,4.757s1.467.778,1.889-.4a2.365,2.365,0,0,0-1.045-3.045c-.022-.489-.111-.756-.2-1.423S12.035-.112,11.924,1.155Z",
    transform: "translate(-10.504 -0.197)",
    fill: "#ffccbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50257",
    "data-name": "Path 50257",
    d: "M23.878,2.351a1.4,1.4,0,0,0-.956,2.089c.467.711,1.333-.089.934-.778A1.284,1.284,0,0,1,23.878,2.351Z",
    transform: "translate(-16.368 -1.259)",
    fill: "#ffccbc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_479",
    "data-name": "Ellipse 479",
    cx: 0.464,
    cy: 0.464,
    rx: 0.464,
    ry: 0.464,
    transform: "translate(6.018 5.572)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_480",
    "data-name": "Ellipse 480",
    cx: 0.464,
    cy: 0.464,
    rx: 0.464,
    ry: 0.464,
    transform: "translate(7.875 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50258",
    "data-name": "Path 50258",
    d: "M34.524,27.035s.478,1.123,1.234.789.845-1.267,1.456-1.656c-.911.467-1.2.978-1.556,1.045s-.511-.423-.511-.423Z",
    transform: "translate(-22.692 -14.019)",
    fill: "#6d4408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50259",
    "data-name": "Path 50259",
    d: "M35.714,16.107C34.73,16.435,32,15.179,32,13.786A3,3,0,0,1,34.786,11c1.393,0,2.786.464,2.786,1.393S37.107,15.643,35.714,16.107Z",
    transform: "translate(-21.339 -5.893)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50260",
    "data-name": "Path 50260",
    d: "M20.838,7.905A2.162,2.162,0,0,0,18.83,9.017C18.948,7.135,20.416,7.105,20.838,7.905Z",
    transform: "translate(-14.284 -3.968)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8463",
    "data-name": "Rectangle 8463",
    width: 12.071,
    height: 1.857,
    transform: "translate(0.446 20.429)",
    fill: "#26c6da"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoobyDooHighlighted);
export default __webpack_public_path__ + "static/media/scoobyDooHighlighted.05669fabe2781357d992cdf44e8ae2f2.svg";
export { ForwardRef as ReactComponent };